export const FETCH_METRICS_MAIN_DASHBOARD = 'FETCH_METRICS_MAIN_DASHBOARD';
export const FETCH_METRICS_MAIN_DASHBOARD_SUCCESS =
  'FETCH_METRICS_MAIN_DASHBOARD_SUCCESS';
export const FETCH_METRICS_MAIN_DASHBOARD_ERROR =
  'FETCH_METRICS_MAIN_DASHBOARD_ERROR';

export const FETCH_GENERALCAUSES_MAIN_DASHBOARD =
  'FETCH_GENERALCAUSES_MAIN_DASHBOARD';
export const FETCH_GENERALCAUSES_MAIN_DASHBOARD_SUCCESS =
  'FETCH_GENERALCAUSES_MAIN_DASHBOARD_SUCCESS';
export const FETCH_GENERALCAUSES_MAIN_DASHBOARD_ERROR =
  'FETCH_GENERALCAUSES_MAIN_DASHBOARD_ERROR';

export const FETCH_DECLARED_STOPS_MAIN_DASHBOARD =
  'FETCH_DECLARED_STOPS_MAIN_DASHBOARD';
export const FETCH_DECLARED_STOPS_MAIN_DASHBOARD_SUCCESS =
  'FETCH_DECLARED_STOPS_MAIN_DASHBOARD_SUCCESS';
export const FETCH_DECLARED_STOPS_MAIN_DASHBOARD_ERROR =
  'FETCH_DECLARED_STOPS_MAIN_DASHBOARD_ERROR';

export const FETCH_MACHINE_STATUS = 'FETCH_MACHINE_STATUS';
export const FETCH_MACHINE_STATUS_SUCCESS = 'FETCH_MACHINE_STATUS_SUCCESS';
export const FETCH_MACHINE_STATUS_ERROR = 'FETCH_MACHINE_STATUS_ERROR';

export const FETCH_MACHINE_STATUS_SMOOTHLY = 'FETCH_MACHINE_STATUS_SMOOTHLY';
export const FETCH_MACHINE_STATUS_SMOOTHLY_SUCCESS =
  'FETCH_MACHINE_STATUS_SMOOTHLY_SUCCESS';
export const FETCH_MACHINE_STATUS_SMOOTHLY_ERROR =
  'FETCH_MACHINE_STATUS_SMOOTHLY_ERROR';
